import Api from '@/services/ServiceBase'
const path = 'keys'

export default {
  addUpdate(key) {
    return Api().post(path, key)
  },
  list(description, page,clientId,appId) {
    return Api().get(path, {
      params: {
        description,
        page,
        clientId,
        appId
      }
    })
  },
  delete(id) {
    return Api().delete(path + `/${id}`)
  }
}
